import { useEffect, useState, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { isMobile } from 'react-device-detect';

const ActionBar = (props) => {
  const [isShown, setIsShown] = useState(false);
  useEffect(() => {
    if (props.selectedRows && props.selectedRows?.length > 0 && !isShown) {
      setIsShown(true);
    }
    if (!props.selectedRows || (props.selectedRows?.length < 1 && isShown)) {
      setIsShown(false);
    }
  }, [props.selectedRows]);

  return (
    <>
      {props.active && props.actionBarComponents?.length > 0 && (
        <div className={`ActionBar ${isShown ? 'shown' : ''} ${isMobile ? 'mobile' : ''}`}>
          <div className='selected-wrapper'>
            {props.intl.formatMessage({ id: 'Selected positions' })}: {props.selectedRows?.length}
          </div>
          <div className={`actions-wrapper`}>{props.actionBarComponents.map((item, key) => cloneElement(item, { key }))}</div>
        </div>
      )}
    </>
  );
};

ActionBar.propTypes = {
  selectedRows: PropTypes.array,
  mobileTexts: PropTypes.bool,
};

export default injectIntl(ActionBar);
